import type { FaireBrandEntity } from "../../entity_types/brand";

export const onboarding_onfaire_1: FaireBrandEntity = {
  token: "onboarding_onfaire_1",
  type: "brand",
  name: "Potluck",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/6edcc1e721d6c6e418cb5378f3f92caca5f10171ea43c6c3da92e2bc6f9da5b1.webp",
  minimumOrderDollars: 100,
  rating: 4.8,
  location: "US",
  tags: ["onboarding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
